import React, { useContext } from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { multiStepContext } from "../StepContext";
import fourthstpe from "../Style/FourthStep.css";

const FourthStep = () => {
  const {
    setCurrentStep,
    setUserData,
    userData,
    submitData,
    finalData,
    user,
    fourthPageData,
    setFourthPageData,
  } = useContext(multiStepContext);

  return (
    <div>
      <div className="section1 ">
        <h2>Finishing up</h2>
        <p>Double-check everything looks OK before confirming.</p>
      </div>

      {fourthPageData.map((data) => {
        const newData1 = data.price1 || data.price2 || data.price3;
        const newData2 = data.option1 || data.option2 || data.option3;
        return (
          <>
            <div className="section2 finishingPlan">
              <div className="line1">
                <div className="plan">
                  <p>{data.name1 || data.name2 || data.name3} (Monthly)</p>

                  <span>Change</span>
                </div>

                <div className="prices">
                  <p>{data.price1 || data.price2 || data.price3}</p>
                </div>
              </div>
              <div className="onlineService">
                <p>{data.Name1}</p>

                <span>{data.option1}</span>
              </div>
              <div className="onlineService">
                <p>{data.Name2}</p>
                <p>{data.option2} </p>
              </div>
              <div className="onlineService">
                <p>{data.Name3}</p>
                <p>{data.option3} </p>
              </div>
            </div>

            <div className="total">
              <p>Total (Per Month) :</p>
              <span> {newData1 + newData2 || newData1 || newData2} </span>
            </div>
          </>
        );
      })}

<div className="btngrp">

<div className="changebtn">

      <button
      className="change"
        onClick={() => {
          setFourthPageData("");
          setUserData("");
          setCurrentStep(2);
        }}
      >
        Change
      </button>
</div>
<div className="secbtn">

<div className="btnback">

      <Button
        style={{ marginRight: "10px" }}
        onClick={() => setCurrentStep(1)}
        variant="contained"
        color="primary"
      >
        Back
      </Button>
</div>
<div className="btnsubmit">

      <Button onClick={() => submitData()} variant="contained" color="primary">
        Submit
      </Button>
</div>
</div>
</div>
    </div>
  );
};

export default FourthStep;
